const round = ( number: number, decimalPlaces: number ): number => {
  const factorOfTen = Math.pow( 10, decimalPlaces )
  return Math.round( number * factorOfTen ) / factorOfTen
}

export default round
